import { IconProps } from "../../types/utils";

const Private = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.8559 8.54774L16.4278 4.09576C16.1567 3.96808 15.8428 3.96808 15.5717 4.09576L6.1436 8.54774C5.97182 8.62916 5.82681 8.75774 5.72557 8.91863C5.62432 9.07934 5.57092 9.26578 5.57164 9.45577V18.4597C5.53057 20.4857 6.44665 22.4125 8.04359 23.6597L15.4036 29.1317V29.1318C15.577 29.2609 15.7875 29.3308 16.0036 29.3308C16.2198 29.3308 16.4304 29.261 16.6036 29.1318L23.9636 23.6598V23.6597C25.5608 22.4125 26.4768 20.4857 26.4357 18.4597V9.45577C26.4357 9.26488 26.3813 9.07792 26.2784 8.91703C26.1756 8.75614 26.0289 8.62792 25.8557 8.54775L25.8559 8.54774ZM24.4279 18.4595C24.4716 19.8548 23.8551 21.189 22.7638 22.0595L15.9999 27.0556L9.23603 22.0394C8.14479 21.1689 7.52819 19.8347 7.57194 18.4394V10.0874L15.9998 6.10349L24.4277 10.1035L24.4279 18.4595Z"
      fill={color || "#242424"}
    />
    <path
      d="M15.9993 15.2356C15.6673 15.2356 15.3488 15.3676 15.1139 15.6024C14.8791 15.837 14.7473 16.1556 14.7473 16.4875C14.7473 16.8197 14.8791 17.1381 15.1139 17.3729C15.3488 17.6077 15.6673 17.7395 15.9993 17.7395C16.3313 17.7395 16.6498 17.6077 16.8847 17.3729C17.1195 17.1381 17.2513 16.8197 17.2513 16.4875C17.2513 16.1556 17.1195 15.837 16.8847 15.6024C16.6498 15.3676 16.3313 15.2356 15.9993 15.2356Z"
      fill={color || "#242424"}
    />
    <path
      d="M20.7597 16.8995C19.5946 18.3408 17.8526 19.1942 16 19.2317C14.1471 19.1942 12.4051 18.3408 11.2402 16.8995C11.0365 16.6628 11.0365 16.3126 11.2402 16.0756C12.4054 14.6344 14.1474 13.781 16 13.7437C17.8528 13.781 19.5948 14.6344 20.7597 16.0756C20.9635 16.3126 20.9635 16.6628 20.7597 16.8995Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Private;
